import React from 'react'
import { Drawer } from 'antd'
import { useTranslation } from 'react-i18next'
import ActivityReferenceTable from './ActivityReferenceTable'

interface ActivityGuideDrawerProps {
  open: boolean
  onClose: () => void
}

const ActivityGuideDrawer: React.FC<ActivityGuideDrawerProps> = ({
  open,
  onClose,
}) => {
  const { t } = useTranslation()

  return (
    <Drawer
      title={t('hh_activity_guide_title')}
      placement='right'
      width={640}
      bodyStyle={{
        padding: 16,
        height: 'calc(100vh - 55px)',
        display: 'flex',
        flexDirection: 'column',
      }}
      open={open}
      onClose={onClose}
      destroyOnClose
    >
      <ActivityReferenceTable scrollY='calc(100vh - 135px)' />
    </Drawer>
  )
}

export default ActivityGuideDrawer
